"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebProfileCheckImage = exports.GoToProfileButton = exports.TextWrapper = exports.ProfileStepWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const elements_1 = require("@src/components/elements");
const web_profile_check_svg_1 = __importDefault(require("@src/illustrations/web-profile-check.svg"));
const styled_breakpoints_1 = require("styled-breakpoints");
exports.ProfileStepWrapper = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	align-items: center;
`;
exports.TextWrapper = styled_components_1.default.div `
	font-size: 1.2rem;
	color: ${props => props.theme.color.gray8};
	margin: 1rem 0 2rem;
`;
exports.GoToProfileButton = (0, styled_components_1.default)(elements_1.Button) `
	height: 60px !important;
	width: 250px;
	font-size: 1.25rem !important;
	display: flex;
	justify-content: center;
`;
exports.WebProfileCheckImage = (0, styled_components_1.default)(web_profile_check_svg_1.default) `
	width: 200px;

	${(0, styled_breakpoints_1.down)('sm')} {
		width: 150px;
	}
`;
